export const upcomingEventsQuery = `
  query($first: Int, $today: String) {
    eventOccurrences(first: $first, where: { dateStart: $today }) {
      nodes {
        eventSlug
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        hideStartTime
        imageSrcset
        specificImage {
          altText
          imageSrcset
          sourceUrl
        }
        start {
          day
          isoDate
          meridiem
          month
          time
          timezone
          year
          weekday
        }
        repeatDescription
        title
        timezoneAbbr
        venue
      }
      pageInfo {
        totalEventOccurrences
      }
    }
  }
`;
